module.exports = __webpack_public_path__ + "img/iswt-2.99ad57e1.jpg";